import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { ActiveIngredientAdminModel } from "../../../models/activeIngredient";
import { TabView, TabPanel } from 'primereact/tabview';
import ActiveIngredientTabBasicInfo from './activeIngredientTabBasicInfo';
import { DrugToFoodAlcoholInteractionModel } from "../../../models/activeIngredient";
import { DrugToDiseaseInteractionAdminModel } from "../../../models/activeIngredient";
import { DrugToDrugInteractionModel } from "../../../models/activeIngredient";
import { IngredientSideEffectModel } from "../../../models/sideEffect";
import { IngredientSideEffectReactionModel } from "../../../models/sideEffect";
import { DosageContentModel } from "../../../models/dosage";
import { DosageLevelModel } from "../../../models/dosage";
import ActiveIngredientTabFoodAlcoholInteraction from './activeIngredientTabFoodAlcoholInteraction';
import ActiveIngredientTabDiseaseInteraction from './activeIngredientTabDiseaseInteraction';
import ActiveIngredientTabDrugInteraction from './activeIngredientTabDrugInteraction';
import ActiveIngredientTabSideEffects from './activeIngredientTabSideEffects';
import ActiveIngredientTabDosage from './activeIngredientTabDosage';
import FoodAlcoholInteractionAddEditDialog from './foodAlcoholInteractionAddEditDialog';
import DiseaseInteractionAddEditDialog from './diseaseInteractionAddEditDialog';
import DrugInteractionAddEditDialog from './drugInteractionAddEditDialog';
import SideEffectAddEditDialog from './sideEffectAddEditDialog';
import DosageLevelAddEditDialog from './dosageLevelAddEditDialog';
import AtcCodeListDialog from './atcCodeListDialog';
import { ImageModel } from "../../../models/imageModel";
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputSwitch } from 'primereact/inputswitch';
import { ATCCodeModel } from "../../../models/atcCode";
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';
import { DrugInteractionContentModel } from '../../../models/activeIngredient/drugInteractionContentModel';
import { IngredientSideEffectContentModel } from '../../../models/sideEffect/ingredientSideEffectContentModel';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { DosageContentContentModel } from '../../../models/dosage/dosageContentContentModel';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentActiveIngredient: ActiveIngredientAdminModel,
}

interface IState {
	activeIngredient: ActiveIngredientAdminModel;
	validationMessage: string;
	isVisibleFoodAlcoholAddEditInteractionDialog: boolean;
	isVisibleDiseaseAddEditInteractionDialog: boolean;
	isVisibleDrugAddEditInteractionDialog: boolean;
	isVisibleSideEffectReactionAddEditDialog: boolean;
	isVisibleDosageLevelAddEditDialog: boolean;
	currentFoodAlcoholInteraction: DrugToFoodAlcoholInteractionModel;
	currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel;
	currentDrugInteraction: DrugToDrugInteractionModel;
	currentSideEffectReaction: IngredientSideEffectReactionModel;
	currentDosageLevel: DosageLevelModel;
	imageUrl: string;
	isWithSideEffects: boolean;
	isWithDosageContent: boolean;
	isActiveIngredientDropdownDisabled: boolean;
	isFoodAlcoholDropdownDisabled: boolean;
	isDiseaseAddEditDisabled: boolean;
	isAnatomicalSystemDropdownDisabled: boolean;
	isVisibleATCCodeListDialog: boolean;
	isVisibleDriveAndMachineAddEditInteractionDialog: boolean;
	isProfessionTypeDropdownDisabled: boolean;
	selectedLangId: number;
	activeIndex: number;
}

class ActiveIngredientAddEditDialog extends React.Component<IProps, IState> {
	op: any;

	constructor(props: IProps) {
		super(props);

		if (!props.currentActiveIngredient.drugToFoodAlcoholInteractions) {
			props.currentActiveIngredient.drugToFoodAlcoholInteractions = new Array<DrugToFoodAlcoholInteractionModel>(0);
		}

		if (!props.currentActiveIngredient.drugToDiseaseInteractions) {
			props.currentActiveIngredient.drugToDiseaseInteractions = new Array<DrugToDiseaseInteractionAdminModel>(0);
		}

		if (!props.currentActiveIngredient.drugToDrugInteractions) {
			props.currentActiveIngredient.drugToDrugInteractions = new Array<DrugToDrugInteractionModel>(0);
		}

		if (!props.currentActiveIngredient.ingredientSideEffect) {
			props.currentActiveIngredient.ingredientSideEffect = new IngredientSideEffectModel();
		}

		if (!props.currentActiveIngredient.ingredientSideEffect.ingredientSideEffectReactions) {
			props.currentActiveIngredient.ingredientSideEffect.ingredientSideEffectReactions = new Array<IngredientSideEffectReactionModel>(0);
		}

		if (!props.currentActiveIngredient.dosageContent) {
			props.currentActiveIngredient.dosageContent = new DosageContentModel();
		}

		if (!props.currentActiveIngredient.dosageContent.dosageLevels) {
			props.currentActiveIngredient.dosageContent.dosageLevels = new Array<DosageLevelModel>(0);
		}

		if (!props.currentActiveIngredient.atcCode) {
			props.currentActiveIngredient.atcCode = new ATCCodeModel();
		}

		this.state = {
			activeIngredient: props.currentActiveIngredient,
			validationMessage: '',
			isVisibleFoodAlcoholAddEditInteractionDialog: false,
			isVisibleDiseaseAddEditInteractionDialog: false,
			isVisibleDrugAddEditInteractionDialog: false,
			isVisibleSideEffectReactionAddEditDialog: false,
			isVisibleDosageLevelAddEditDialog: false,
			currentFoodAlcoholInteraction: new DrugToFoodAlcoholInteractionModel(),
			currentDiseaseInteraction: new DrugToDiseaseInteractionAdminModel(),
			currentDrugInteraction: new DrugToDrugInteractionModel(),
			currentSideEffectReaction: new IngredientSideEffectReactionModel(),
			currentDosageLevel: new DosageLevelModel(),
			imageUrl: '',
			isWithSideEffects: props.currentActiveIngredient.isWithSideEffects,
			isWithDosageContent: props.currentActiveIngredient.isWithDosageContent,
			isActiveIngredientDropdownDisabled: false,
			isFoodAlcoholDropdownDisabled: false,
			isDiseaseAddEditDisabled: false,
			isAnatomicalSystemDropdownDisabled: false,
			isVisibleATCCodeListDialog: false,
			isVisibleDriveAndMachineAddEditInteractionDialog: false,
			isProfessionTypeDropdownDisabled: false,
			selectedLangId: Lang.bg,
			activeIndex: TabIndexes.BasicInfo
		};
	}

	handleSetIsDosageContent = (e) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		activeIngredient.isWithDosageContent = e.value;
		const dosageContent: DosageContentModel = { ...activeIngredient.dosageContent }
		let contentList = new Array<DosageContentContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new DosageContentContentModel();
			content.langId = parseInt(Lang[k]);
			content.summary = '';
			content.overdoseDescription = '';
			content.professionalDescription = '';
			content.doseAdjustments = '';
			content.precautions = '';
			content.otherComments = '';
			content.otherInformation = '';
			contentList.push(content);
		});

		dosageContent.dosageContentContent = contentList;
		activeIngredient.dosageContent = dosageContent;

		this.setState({
			isWithDosageContent: e.value,
			activeIngredient: activeIngredient
		});
	}

	handleSetIsSideEffects = (e) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		activeIngredient.isWithSideEffects = e.value;
		const sideEffects: IngredientSideEffectModel = { ...activeIngredient.ingredientSideEffect };
		let contentList = new Array<IngredientSideEffectContentModel>(0);
		const langKeys = HelperFunctions.getEnumKeys(Lang);

		langKeys.map(k => {
			let content = new IngredientSideEffectContentModel();
			content.langId = parseInt(Lang[k]);
			content.consumerDescription = '';
			content.otherInformation = '';
			content.overdoseDescription = '';
			content.professionalDescription = '';
			content.summary = '';
			contentList.push(content);
		});

		sideEffects.ingredientSideEffectContent = contentList;
		activeIngredient.ingredientSideEffect = sideEffects;

		this.setState({
			isWithSideEffects: e.value,
			activeIngredient: activeIngredient
		});
	}

	handleIngredientSideEffectChange = (key, value) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		const currentIngredientSideEffectModel: IngredientSideEffectModel = { ...activeIngredient.ingredientSideEffect };
		let content = currentIngredientSideEffectModel.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}

		activeIngredient.ingredientSideEffect = currentIngredientSideEffectModel;
		this.setState({ activeIngredient: { ...activeIngredient } });
	};

	handleDosageContentChange = (key, value) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		const currentDosageContent: DosageContentModel = { ...activeIngredient.dosageContent };
		let content = currentDosageContent.dosageContentContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}

		activeIngredient.dosageContent = currentDosageContent;
		this.setState({ activeIngredient: { ...activeIngredient } });
	};

	handleChange = (key, value) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		activeIngredient[key] = value;
		this.setState({ activeIngredient: { ...activeIngredient } });
	};

	isValidAddEditForm() {
		let message = '';
		this.setState({
			validationMessage: ''
		});
		if ((!this.state.activeIngredient.activeIngredientName || this.state.activeIngredient.activeIngredientName.trim() == '')) {
			message += "Please enter 'Name'.<br />";
		}
		this.setState({
			validationMessage: message
		});
		return message == '';
	}

	handleSaveButton = (event, close) => {
		event.preventDefault();
		if (!this.isValidAddEditForm()) return;

		const activeIngredient = this.state.activeIngredient;
		this.props.saveClick(activeIngredient, close);
	}

	handleCancelButton = () => {
		this.props.cancelClick();
	}

	handleFoodAlcoholCancelButton = () => {
		this.handleSetIsVisibleFoodAlcoholAddEditInteractionDialog(false);
	};

	handleDiseaseCancelButton = () => {
		this.handleSetIsVisibleDiseaseAddEditInteractionDialog(false);
	};

	handleDrugCancelButton = () => {
		this.handleSetIsVisibleDrugAddEditInteractionDialog(false);
	};

	handleSideEffectReactionCancelButton = () => {
		this.handleSetIsVisibleSideEffectReactionAddEditDialog(false);
	};

	handleATCCodeCancelButton = () => {
		this.handleSetIsVisibleATCCodeListDialog(false);
	};

	handleSetIsAnatomicalSystemDropdownDisabled = (show) => {
		this.setState({
			isAnatomicalSystemDropdownDisabled: show
		})
	}

	handleDosageLevelCancelButton = () => {
		this.handleSetIsVisibleDosageLevelAddEditDialog(false);
	};

	handleSetIsVisibleFoodAlcoholAddEditInteractionDialog = (show) => {
		this.setState({
			isVisibleFoodAlcoholAddEditInteractionDialog: show
		})
	}

	handleSetIsVisibleDiseaseAddEditInteractionDialog = (show) => {
		this.setState({
			isVisibleDiseaseAddEditInteractionDialog: show
		})
	}

	handleSetIsVisibleDrugAddEditInteractionDialog = (show) => {
		this.setState({
			isVisibleDrugAddEditInteractionDialog: show
		})
	}

	handleSetIsActiveIngredientDropdownDisabled = (show) => {
		this.setState({
			isActiveIngredientDropdownDisabled: show
		})
	}

	handleSetIsFoodAlcoholDropdownDisabled = (show) => {
		this.setState({
			isFoodAlcoholDropdownDisabled: show
		})
	}

	handleSetIsProfessionTypeDropdownDisabled = (show) => {
		this.setState({
			isProfessionTypeDropdownDisabled: show
		})
	}

	handleSetIsDiseaseAddEditDisabled = (show) => {
		this.setState({
			isDiseaseAddEditDisabled: show
		})
	}

	handleSetIsVisibleSideEffectReactionAddEditDialog = (show) => {
		this.setState({
			isVisibleSideEffectReactionAddEditDialog: show
		})
	}

	handleSetIsVisibleATCCodeListDialog = (show) => {
		this.setState({
			isVisibleATCCodeListDialog: show
		})
	}

	handleSetIsVisibleDosageLevelAddEditDialog = (show) => {
		this.setState({
			isVisibleDosageLevelAddEditDialog: show
		})
	}

	handleCurrentFoodAlcoholInteraction = (foodAlcoholInteraction: DrugToFoodAlcoholInteractionModel) => {
		this.setState({ currentFoodAlcoholInteraction: { ...foodAlcoholInteraction } });
	}

	handleCurrentDiseaseInteraction = (diseaseInteraction: DrugToDiseaseInteractionAdminModel) => {
		this.setState({ currentDiseaseInteraction: { ...diseaseInteraction } });
	}

	handleCurrentDrugInteraction = (drugInteraction: DrugToDrugInteractionModel) => {
		this.setState({ currentDrugInteraction: { ...drugInteraction } });
	}

	handleCurrentSideEffectReaction = (currentSideEffectReaction: IngredientSideEffectReactionModel) => {
		this.setState({ currentSideEffectReaction: { ...currentSideEffectReaction } });
	}

	handleCurrentDosageLevel = (currentDosageLevel: DosageLevelModel) => {
		this.setState({ currentDosageLevel: { ...currentDosageLevel } });
	}

	removeFoodAlcoholInteractionClick(selectedIngredientId, interactionTypeId, foodAlcoholId) {
		const activeIngredient = this.state.activeIngredient;
		const activeIngredientIndex = activeIngredient.drugToFoodAlcoholInteractions.findIndex(a =>
			a.selectedIngredientId === selectedIngredientId && a.interactionTypeId === interactionTypeId && a.foodAlcoholId === foodAlcoholId);

		activeIngredient.drugToFoodAlcoholInteractions.splice(activeIngredientIndex, 1);
		this.setState({
			activeIngredient: activeIngredient
		})
	}

	removeDiseaseInteractionClick(selectedIngredientId, interactionTypeId, diseaseId) {
		const activeIngredient = this.state.activeIngredient;
		const activeIngredientIndex = activeIngredient.drugToDiseaseInteractions.findIndex(a =>
			a.selectedIngredientId === selectedIngredientId && a.interactionTypeId === interactionTypeId && a.disease.diseaseId === diseaseId);

		activeIngredient.drugToDiseaseInteractions.splice(activeIngredientIndex, 1);
		this.setState({
			activeIngredient: activeIngredient
		})
	}

	removeDrugInteractionClick(selectedIngredientId, interactionTypeId, interactionIngredientId) {
		const activeIngredient = this.state.activeIngredient;
		const activeIngredientIndex = activeIngredient.drugToDrugInteractions.findIndex(a =>
			a.selectedIngredientId === selectedIngredientId && a.interactionTypeId === interactionTypeId && a.interactionIngredientId === interactionIngredientId);

		activeIngredient.drugToDrugInteractions.splice(activeIngredientIndex, 1);
		this.setState({
			activeIngredient: activeIngredient
		})
	}

	removeSideEffectReactionClick(ingredientSideEffectReactionId) {
		const activeIngredient = this.state.activeIngredient;
		const activeIndex = activeIngredient.ingredientSideEffect.ingredientSideEffectReactions.findIndex(a =>
			a.ingredientSideEffectReactionId === ingredientSideEffectReactionId);

		activeIngredient.ingredientSideEffect.ingredientSideEffectReactions.splice(activeIndex, 1);
		this.setState({
			activeIngredient: activeIngredient
		})
	}

	removeDosageLevelClick(dosageLevelId) {
		const activeIngredient = this.state.activeIngredient;
		const activeIndex = activeIngredient.dosageContent.dosageLevels.findIndex(a =>
			a.dosageLevelId === dosageLevelId);

		activeIngredient.dosageContent.dosageLevels.splice(activeIndex, 1);
		this.setState({
			activeIngredient: activeIngredient
		})
	}

	//TODO: Ask about validations
	handleFoodAlcoholInteractionAddButton = (currentFoodAlcoholInteraction: DrugToFoodAlcoholInteractionModel) => {
		if (this.state.activeIngredient.drugToFoodAlcoholInteractions
			.some(f => f.selectedIngredientId === currentFoodAlcoholInteraction.selectedIngredientId &&
				f.foodAlcoholId === currentFoodAlcoholInteraction.foodAlcoholId)) {

			const activeInteractionIndex = this.state.activeIngredient.drugToFoodAlcoholInteractions
				.findIndex(a => a.selectedIngredientId === currentFoodAlcoholInteraction.selectedIngredientId &&
					a.foodAlcoholId === currentFoodAlcoholInteraction.foodAlcoholId);

			this.state.activeIngredient.drugToFoodAlcoholInteractions[activeInteractionIndex] = currentFoodAlcoholInteraction;
		} else {

			this.state.activeIngredient.drugToFoodAlcoholInteractions.push(currentFoodAlcoholInteraction);
		};

		this.handleSetIsVisibleFoodAlcoholAddEditInteractionDialog(false);
	}

	//TODO: Ask about validations
	handleDiseaseInteractionAddButton = (currentDiseaseInteraction: DrugToDiseaseInteractionAdminModel) => {
		if (this.state.activeIngredient.drugToDiseaseInteractions
			.some(f => f.selectedIngredientId === currentDiseaseInteraction.selectedIngredientId &&
				f.disease.diseaseId === currentDiseaseInteraction.disease.diseaseId)) {

			const activeInteractionIndex = this.state.activeIngredient.drugToDiseaseInteractions
				.findIndex(a => a.selectedIngredientId === currentDiseaseInteraction.selectedIngredientId &&
					a.disease.diseaseId === currentDiseaseInteraction.disease.diseaseId);

			this.state.activeIngredient.drugToDiseaseInteractions[activeInteractionIndex] = currentDiseaseInteraction;
		} else {

			this.state.activeIngredient.drugToDiseaseInteractions.push(currentDiseaseInteraction);
		};

		this.handleSetIsVisibleDiseaseAddEditInteractionDialog(false);
	}

	handleDrugInteractionAddButton = (currentDrugInteraction: DrugToDrugInteractionModel) => {

		if (this.state.activeIngredient.drugToDrugInteractions.some(f => f.selectedIngredientId === currentDrugInteraction.selectedIngredientId &&
			f.interactionIngredientId === currentDrugInteraction.interactionIngredientId)) {

			const activeInteractionIndex = this.state.activeIngredient.drugToDrugInteractions
				.findIndex(a => a.selectedIngredientId === currentDrugInteraction.selectedIngredientId &&
					a.interactionIngredientId === currentDrugInteraction.interactionIngredientId);

			this.state.activeIngredient.drugToDrugInteractions[activeInteractionIndex] = currentDrugInteraction;
		} else {
			this.state.activeIngredient.drugToDrugInteractions.push(currentDrugInteraction);
		};

		this.handleSetIsVisibleDrugAddEditInteractionDialog(false);
	}

	handleSideEffectAddButton = (currentSideEffectReaction: IngredientSideEffectReactionModel) => {
		if (this.state.activeIngredient.ingredientSideEffect.ingredientSideEffectReactions
			.some(f => f.ingredientSideEffectReactionId === currentSideEffectReaction.ingredientSideEffectReactionId)) {

			let activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
			let activeIndex = activeIngredient.ingredientSideEffect.ingredientSideEffectReactions
				.findIndex(a => a.ingredientSideEffectReactionId === currentSideEffectReaction.ingredientSideEffectReactionId);

			activeIngredient.ingredientSideEffect.ingredientSideEffectReactions[activeIndex] = { ...currentSideEffectReaction };
			this.setState({ activeIngredient: { ...activeIngredient } });
		} else {

			let activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
			activeIngredient.ingredientSideEffect.ingredientSideEffectReactions.push(currentSideEffectReaction);
			this.setState({ activeIngredient: { ...activeIngredient } });
		};

		this.handleSetIsVisibleSideEffectReactionAddEditDialog(false);
	}

	handleDosageLevelAddButton = (currentDosageLevel: DosageLevelModel) => {
		if (this.state.activeIngredient.dosageContent.dosageLevels
			.some(f => f.dosageLevelId === currentDosageLevel.dosageLevelId)) {

			const activeIndex = this.state.activeIngredient.dosageContent.dosageLevels
				.findIndex(a => a.dosageLevelId === currentDosageLevel.dosageLevelId);

			this.state.activeIngredient.dosageContent.dosageLevels[activeIndex] = currentDosageLevel;
		} else {
			this.state.activeIngredient.dosageContent.dosageLevels.push(currentDosageLevel);
		};

		this.handleSetIsVisibleDosageLevelAddEditDialog(false);
	}

	handleATCCodeAddButton = (currentATCCode: ATCCodeModel) => {
		this.state.activeIngredient.atcCode = currentATCCode;
		this.handleSetIsVisibleATCCodeListDialog(false);
	}

	handleATCCodeRemoveClick = () => {
		let activeIngredient = this.state.activeIngredient;
		activeIngredient.atcCode = undefined;

		this.setState({
			activeIngredient: activeIngredient
		});
	}

	handleRemoveImage = () => {
		let activeIngredient = this.state.activeIngredient;
		activeIngredient.image = undefined;

		this.setState({
			activeIngredient: activeIngredient
		});
	}

	handleToggleImage = (e, imageUrl) => {
		this.setState({
			imageUrl: imageUrl
		})
		this.op.toggle(e);
	}

	handleUploadImage = (imageModel: ImageModel) => {
		if (imageModel) {
			let activeIngredient = this.state.activeIngredient;
			activeIngredient.image = imageModel;

			this.setState({
				activeIngredient: { ...activeIngredient }
			});
		}
	}

	onLangChange = (lang) => {
		this.setState({ selectedLangId: lang }, this.checkIndexes);
	}

	checkIndexes = () => {
		const index = this.state.activeIndex;
		if (index == TabIndexes.Dosage || index == TabIndexes.SideEffects) {
			setTimeout(() => {
				this.setState({ activeIndex: TabIndexes.NonExisting }, () => {
					this.setState({ activeIndex: index })
				});
			});
		}
	}

	getValueContent = (key) => {
		let content = this.state.activeIngredient.activeIngredientContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getSideEffectValueContent = (key) => {
		let content = this.state.activeIngredient.ingredientSideEffect.ingredientSideEffectContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	getDosageContentValueContent = (key) => {
		let content = this.state.activeIngredient.dosageContent.dosageContentContent.find(r => r.langId == this.state.selectedLangId)
		if (content && content[key]) {
			return content[key];
		}
		return '';
	}

	handleContentChange = (key, value) => {
		const activeIngredient: ActiveIngredientAdminModel = { ...this.state.activeIngredient };
		let content = activeIngredient.activeIngredientContent.find(r => r.langId == this.state.selectedLangId);
		if (content) {
			content[key] = value;
		}
		this.setState({ activeIngredient: { ...activeIngredient } });
	}

	public render() {
		const { activeIngredient, imageUrl } = this.state;
		let header = 'Active ingradient ' +
			(activeIngredient.activeIngredientName ? ' -' : '') +
			(activeIngredient.activeIngredientName ? ' ' + activeIngredient.activeIngredientName : '');

		return (
			<>
				<Dialog header={header} responsive={true} width="80%"
					modal={true}
					visible={this.props.isVisible}
					onHide={this.handleCancelButton}
					footer={
						<div>
							<Button label="Save" icon="pi pi-check" onClick={(e) => this.handleSaveButton(e, false)} className="p-button-raised" />
							<Button label="Save & Close" icon="pi pi-check" onClick={(e) => this.handleSaveButton(e, true)} className="p-button-success p-button-raised" />
							<Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
						</div>}
				>
					<div style={{ minHeight: '600px', maxHeight: '650px', overflowY: 'auto' }}>
						{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
						<div style={{ maxWidth: 70 }}>
							<Language selectedLang={this.state.selectedLangId} onLangChange={this.onLangChange}></Language>
						</div>
						<TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
							<TabPanel header="Basic info">
								<div className="p-grid p-fluid p-md-12">
									<ActiveIngredientTabBasicInfo
										handleChange={this.handleChange}
										activeIngredient={activeIngredient}
										uploadImageClick={this.handleUploadImage}
										removeImageClick={this.handleRemoveImage}
										toggleImageClick={this.handleToggleImage}
										setIsVisibleATCCodeListDialog={this.handleSetIsVisibleATCCodeListDialog}
										removeATCCodeClick={this.handleATCCodeRemoveClick}
										handleContentChange={this.handleContentChange}
										getContentValue={this.getValueContent}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Drug Interactions">
								<div className="p-grid p-fluid p-md-12">
									<ActiveIngredientTabDrugInteraction
										onAddEditDrugInteractionClick={this.handleCurrentDrugInteraction}
										activeIngredient={activeIngredient}
										setIsVisibleDrugAddEditInteractionDialog={this.handleSetIsVisibleDrugAddEditInteractionDialog}
										setIsActiveIngredientDropdownDisabled={this.handleSetIsActiveIngredientDropdownDisabled}
										removeDrugInteractionClick={(selectedIngredientId, interactionTypeId, interactionIngredientId) =>
											this.removeDrugInteractionClick(selectedIngredientId, interactionTypeId, interactionIngredientId)}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Disease Interactions">
								<div className="p-grid p-fluid p-md-12">
									<ActiveIngredientTabDiseaseInteraction
										onAddEditDiseaseInteractionClick={this.handleCurrentDiseaseInteraction}
										activeIngredient={activeIngredient}
										setIsVisibleDiseaseAddEditInteractionDialog={this.handleSetIsVisibleDiseaseAddEditInteractionDialog}
										setIsDiseaseDropdownDisabled={this.handleSetIsDiseaseAddEditDisabled}
										removeDiseaseInteractionClick={(selectedIngredientId, interactionTypeId, diseaseId) =>
											this.removeDiseaseInteractionClick(selectedIngredientId, interactionTypeId, diseaseId)}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Food/Alcohol Interactions">
								<div className="p-grid p-fluid p-md-12">
									<ActiveIngredientTabFoodAlcoholInteraction
										onAddEditFoodAlcoholInteractionClick={this.handleCurrentFoodAlcoholInteraction}
										activeIngredient={activeIngredient}
										setIsVisibleFoodAlcoholAddEditInteractionDialog={this.handleSetIsVisibleFoodAlcoholAddEditInteractionDialog}
										setIsFoodAlcoholDropdownDisabled={this.handleSetIsFoodAlcoholDropdownDisabled}
										removeFoodAlcoholInteractionClick={(selectedIngredientId, interactionTypeId, foodAlcoholId) =>
											this.removeFoodAlcoholInteractionClick(selectedIngredientId, interactionTypeId, foodAlcoholId)}
									/>
								</div>
							</TabPanel>
							<TabPanel header="Side Effects">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Ingredient side effects:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithSideEffects}
											onChange={(e) => this.handleSetIsSideEffects(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithSideEffects
										?
										<ActiveIngredientTabSideEffects
											activeIngredient={activeIngredient}
											handleIngredientSideEffectChange={this.handleIngredientSideEffectChange}
											onAddEditSideEffectReactionClick={this.handleCurrentSideEffectReaction}
											setIsVisibleSideEffectReactionAddEditDialog={this.handleSetIsVisibleSideEffectReactionAddEditDialog}
											setIsAnatomicalSystemDropdownDisabled={this.handleSetIsAnatomicalSystemDropdownDisabled}
											getContentValue={this.getSideEffectValueContent}
											removeSideEffectReactionClick={(ingredientSideEffectReactionId) => this.removeSideEffectReactionClick(ingredientSideEffectReactionId)}
										/>
										: null
									}
								</div>
							</TabPanel>
							<TabPanel header="Dosage">
								<div className="p-grid p-fluid p-md-12">
									<div className="p-col-12 p-md-2">
										<strong><label>Ingredient dosage:</label></strong>
									</div>
									<div className="p-col-12 p-md-2">
										<InputSwitch
											checked={this.state.isWithDosageContent}
											onChange={(e) => this.handleSetIsDosageContent(e)}>
										</InputSwitch>
									</div>
									{this.state.isWithDosageContent
										?
										<ActiveIngredientTabDosage
											activeIngredient={activeIngredient}
											handleDosageContentChange={this.handleDosageContentChange}
											onAddEditDosageLevelClick={this.handleCurrentDosageLevel}
											setIsVisibleDosageLevelAddEditDialog={this.handleSetIsVisibleDosageLevelAddEditDialog}
											removeDosageLevelClick={(dosageLevelId) => this.removeDosageLevelClick(dosageLevelId)}
											getContentValue={this.getDosageContentValueContent}
										/>
										: null
									}
								</div>
							</TabPanel>
						</TabView>
					</div>
				</Dialog >

				{this.state.isVisibleATCCodeListDialog ? (
					<AtcCodeListDialog
						selectedATCCode={this.state.activeIngredient.atcCode}
						addClick={this.handleATCCodeAddButton}
						cancelClick={this.handleATCCodeCancelButton}
						isVisible={this.state.isVisibleATCCodeListDialog}
					/>
				) : null}

				{this.state.isVisibleFoodAlcoholAddEditInteractionDialog ? (
					<FoodAlcoholInteractionAddEditDialog
						currentActiveIngredientId={this.state.activeIngredient.activeIngredientId}
						currentFoodAlcoholInteraction={this.state.currentFoodAlcoholInteraction}
						okClick={this.handleFoodAlcoholInteractionAddButton}
						cancelClick={this.handleFoodAlcoholCancelButton}
						isVisible={this.state.isVisibleFoodAlcoholAddEditInteractionDialog}
						isFoodAlcoholDropdownDisabled={this.state.isFoodAlcoholDropdownDisabled}
						selectedLangId={this.state.selectedLangId}
					/>
				) : null}

				{this.state.isVisibleDiseaseAddEditInteractionDialog ? (
					<DiseaseInteractionAddEditDialog
						currentDiseaseInteraction={this.state.currentDiseaseInteraction}
						okClick={this.handleDiseaseInteractionAddButton}
						cancelClick={this.handleDiseaseCancelButton}
						isVisible={this.state.isVisibleDiseaseAddEditInteractionDialog}
						isDiseaseAddEditDisabled={this.state.isDiseaseAddEditDisabled}
						selectedLangId={this.state.selectedLangId}
					/>
				) : null}

				{this.state.isVisibleDrugAddEditInteractionDialog ? (
					<DrugInteractionAddEditDialog
						currentActiveIngredientId={this.state.activeIngredient.activeIngredientId}
						currentDrugInteraction={this.state.currentDrugInteraction}
						okClick={this.handleDrugInteractionAddButton}
						cancelClick={this.handleDrugCancelButton}
						isVisible={this.state.isVisibleDrugAddEditInteractionDialog}
						isActiveIngredientDropdownDisabled={this.state.isActiveIngredientDropdownDisabled}
						selectedLangId={this.state.selectedLangId}
					/>
				) : null}

				{this.state.isVisibleSideEffectReactionAddEditDialog ? (
					<SideEffectAddEditDialog
						currentSideEffectReaction={this.state.currentSideEffectReaction}
						okClick={this.handleSideEffectAddButton}
						cancelClick={this.handleSideEffectReactionCancelButton}
						isVisible={this.state.isVisibleSideEffectReactionAddEditDialog}
						isAnatomicalSystemDropdownDisabled={this.state.isAnatomicalSystemDropdownDisabled}
						selectedLangId={this.state.selectedLangId}
					/>
				) : null}

				{this.state.isVisibleDosageLevelAddEditDialog ? (
					<DosageLevelAddEditDialog
						selectedLangId={this.state.selectedLangId}
						currentDosageLevel={this.state.currentDosageLevel}
						okClick={this.handleDosageLevelAddButton}
						cancelClick={this.handleDosageLevelCancelButton}
						isVisible={this.state.isVisibleDosageLevelAddEditDialog}
					/>
				) : null}

				<OverlayPanel ref={(el) => this.op = el} dismissable={true}>
					<img src={imageUrl} />
				</OverlayPanel>

			</>
		)
	}
}

export default ActiveIngredientAddEditDialog;

enum TabIndexes {
	BasicInfo = 0,
	Drug = 1,
	Disease = 2,
	FoodAndAlcohol = 3,
	SideEffects = 4,
	Dosage = 5,
	NonExisting = 100
}